import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";

import { useEffect, useState } from "react";
import { CalendarDaysIcon, XCircleIcon } from "@heroicons/react/24/solid";
import { useDispatch, useSelector } from "react-redux";
import ScrollToTop from "@/components/ScrollToTop";
import ShowLoader from "@/components/Loader";
import Select from "react-select";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
    fetchCountry,
    fetchCity,
    fetchOffice,
} from "@/store/slices/internalUsersSlice";
import { Input, Typography } from "@material-tailwind/react";
import { assignRfqToSalesManager, fetchSalesManager, getRfqCommission, getSalesMemberById, resetStatus, updateRfqCommission } from "@/store/slices/rfqSlice";
import Toaster from "@/components/Toaster";
import { getSettingData } from "@/store/slices/settingSlice";
import { useTranslation } from "react-i18next";
import useHasPermission from "@/components/useHasPermission";

const customSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        borderRadius: '8px',
        minHeight: '44px',
        borderColor: state.isFocused ? '#212121' : '#b0bec5',
        boxShadow: state.isFocused ? '0 0 0 1px #212121' : 'none',
        '&:hover': {
            borderColor: state.isFocused ? '#212121' : '#b0bec5',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#9e9e9e',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 50,
        borderRadius: '8px',
    })
};
const priorities = [
    {
        label: "High",
        value: "high"
    },
    {
        label: "Medium",
        value: "medium"
    },
    {
        label: "Low",
        value: "low"
    }
];
const noHTMLRegex = /^(?!.*<[^>]*>).*$/;
const noCodeRegex = /^(?!.*(javascript:|<script|<\/script>|<style|<\/style>|<iframe|<\/iframe>)).*$/i;
const notBlankRegex = /\S/;
const noConsecutiveSpecialChars = /^(?!.*([!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])\1).*$/;
const noLeadingTrailingPunct = /^(?!^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?<![!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]$).*$/;

// ... existing imports

export function EditRFQCommissionDeadline({ isOpen, onClose, rfqId }) {
    const dispatch = useDispatch();
    const { t } = useTranslation('order');
    const { t: ct } = useTranslation('common');

    const { settings } = useSelector((state) => state.setting);
    // Destructure with a default empty array to be safe
    const { rfq_commission, loading } = useSelector((state) => state.rfq);

    const { user } = useSelector((state) => state.user);
    const currentUserRole = user?.roles?.[0] || "";
    const showCity = currentUserRole !== "Finance";
    const showFinance = currentUserRole === "Finance" || currentUserRole === "Administrator" || currentUserRole === "Sub Admin";

    const isAdminRole = currentUserRole === "Administrator" || currentUserRole === "Sub Admin";
    const isMember = !isAdminRole && user?.designation?.toLowerCase() === "member";

    // const schema = (t, rfq_commission) => yup.object().shape({
    //     deadline: yup.string().required(t('deadline_date_required')),
    //     priority: yup.string().required(t('priority_required')),
    //     commission_type: yup.string().required(t('commission_type_is_required')),
    //     notes: yup.string()
    //         .required(t('note_is_required'))
    //         .matches(notBlankRegex, t('note_cannot_be_empty'))
    //         .matches(noHTMLRegex, t('html_tags_not_allowed'))
    //         .matches(noCodeRegex, t('code_not_allowed'))
    //         .matches(noConsecutiveSpecialChars, t('no_consecutive_special_chars'))
    //         .matches(noLeadingTrailingPunct, t('no_leading_trailing_punctuation'))
    //         .min(2, t('note_min_length'))
    //         .max(100, t('note_max_length')),

    //     commission_city_manager: yup
    //         .number()
    //         .typeError(t('logistic_manager_commission_required'))
    //         .min(0, t('minimum_value_is_0'))
    //         .when("commission_type", {
    //             is: "percentage",
    //             then: (s) => s.max(100, t('percentage_cannot_exceed_100')),
    //             otherwise: (s) => s.max(99999, t('commission_cannot_exceed_99999')),
    //         }),

    //     // commission_city_rep: yup
    //     //     .number()
    //     //     .typeError(t('city_rep_commission_required'))
    //     //     .min(0, t('minimum_value_is_0'))
    //     //     .when("commission_type", {
    //     //         is: "percentage",
    //     //         then: (s) => s.max(100, t('percentage_cannot_exceed_100')),
    //     //         otherwise: (s) => s.max(99999, t('commission_cannot_exceed_99999')),
    //     //     }),

    //     time_slot_from_city_manager: yup
    //         .string()
    //         .required(t('logistic_manager_timeslot_required'))
    //         .test("from>=now", t('logistic_manager_from_in_past'), function (v) {
    //             if (!v) return true;
    //             return new Date(v).getTime() >= new Date().getTime();
    //         })
    //         .test("from<=deadline", t('logistic_manager_from_exceed_deadline'), function (v) {
    //             const deadline = this.parent?.deadline;
    //             if (!v || !deadline) return true;
    //             return new Date(v).getTime() <= new Date(deadline).getTime();
    //         }),
    //     time_slot_to_city_manager: yup
    //         .string()
    //         .required(t('logistic_manager_timeslot_required'))
    //         .test("to<=deadline", t('logistic_manager_to_exceed_deadline'), function (v) {
    //             const deadline = this.parent?.deadline;
    //             if (!v || !deadline) return true;
    //             return new Date(v).getTime() <= new Date(deadline).getTime();
    //         })
    //         .test("to>=from", t('logistic_manager_to_before_from'), function (v) {
    //             const from = this.parent?.time_slot_from_city_manager;
    //             if (!v || !from) return true;
    //             return new Date(v).getTime() >= new Date(from).getTime();
    //         }),

    //     // time_slot_from_city_rep: yup
    //     //     .string()
    //     //     .required(t('logistic_member_timeslot_required'))
    //     //     .test("from>=now", t('logistic_member_from_in_past'), function (v) {
    //     //         if (!v) return true;
    //     //         return new Date(v).getTime() >= new Date().getTime();
    //     //     })
    //     //     .test("from<=deadline", t('logistic_member_from_exceed_deadline'), function (v) {
    //     //         const deadline = this.parent?.deadline;
    //     //         if (!v || !deadline) return true;
    //     //         return new Date(v).getTime() <= new Date(deadline).getTime();
    //     //     }),
    //     // time_slot_to_city_rep: yup
    //     //     .string()
    //     //     .required(t('logistic_member_timeslot_required'))
    //     //     .test("to<=deadline", t('logistic_member_to_exceed_deadline'), function (v) {
    //     //         const deadline = this.parent?.deadline;
    //     //         if (!v || !deadline) return true;
    //     //         return new Date(v).getTime() <= new Date(deadline).getTime();
    //     //     })
    //     //     .test("to>=from", t('logistic_member_to_before_from'), function (v) {
    //     //         const from = this.parent?.time_slot_from_city_rep;
    //     //         if (!v || !from) return true;
    //     //         return new Date(v).getTime() >= new Date(from).getTime();
    //     //     }),
    //     deduction_reason: yup.string().when([], {
    //         is: () => true,
    //         then: (schema) =>
    //             schema.test(
    //                 "deduction-reason-required",
    //                 t('deduction_reason_required_on_change'),
    //                 function (value) {

    //                     const {
    //                         commission_city_manager,
    //                         commission_city_rep,
    //                     } = this.parent;

    //                     if (!rfq_commission) return true;

    //                     const changed =
    //                         Number(commission_city_manager) !== Number(rfq_commission.commission_city_manager) ||
    //                         Number(commission_city_rep) !== Number(rfq_commission.commission_city_rep);

    //                     if (!changed) return true;

    //                     if (!value || !value.trim()) {
    //                         return this.createError({
    //                             message: t('deduction_reason_is_required'),
    //                         });
    //                     }

    //                     if (value.trim().length < 5) {
    //                         return this.createError({
    //                             message: t('deduction_reason_min_length'),
    //                         });
    //                     }

    //                     if (value.trim().length > 255) {
    //                         return this.createError({
    //                             message: t('deduction_reason_max_length'),
    //                         });
    //                     }

    //                     return true;
    //                 }
    //             ),
    //     }),

    // });

    const schema = (t, rfq_commission, currentUserRole, isMember) => {
        const showCity = currentUserRole !== "Finance";
        const showFinance = currentUserRole === "Finance" || currentUserRole === "Administrator" || currentUserRole === "Sub Admin";

        const cityManagerRequired = showCity && !isMember;
        const financeManagerRequired = showFinance && !isMember;

        return yup.object().shape({
            deadline: yup.string().required(t('deadline_date_required')),
            priority: yup.string().required(t('priority_required')),
            commission_type: yup.string().required(t('commission_type_is_required')),
            notes: yup.string()
                .required(t('note_is_required'))
                .matches(notBlankRegex, t('note_cannot_be_empty'))
                .matches(noHTMLRegex, t('html_tags_not_allowed'))
                .matches(noCodeRegex, t('code_not_allowed'))
                .matches(noConsecutiveSpecialChars, t('no_consecutive_special_chars'))
                .matches(noLeadingTrailingPunct, t('no_leading_trailing_punctuation'))
                .min(2, t('note_min_length'))
                .max(100, t('note_max_length')),

            // City Manager — only required when visible
            commission_city_manager: showCity
                ? yup.number()
                    .typeError(t('logistic_manager_commission_required'))
                    .min(0, t('minimum_value_is_0'))
                    .when("commission_type", {
                        is: "percentage",
                        then: (s) => s.max(100, t('percentage_cannot_exceed_100')),
                        otherwise: (s) => s.max(99999, t('commission_cannot_exceed_99999')),
                    })
                : yup.number().nullable().notRequired(),

            time_slot_from_city_manager: showCity
                ? yup.string()
                    .required(t('logistic_manager_timeslot_required'))
                    .test("from>=now", t('logistic_manager_from_in_past'), (v) => !v || new Date(v).getTime() >= Date.now())
                    .test("from<=deadline", t('logistic_manager_from_exceed_deadline'), function (v) {
                        const deadline = this.parent?.deadline;
                        if (!v || !deadline) return true;
                        return new Date(v).getTime() <= new Date(deadline).getTime();
                    })
                : yup.string().nullable().notRequired(),

            time_slot_to_city_manager: showCity
                ? yup.string()
                    .required(t('logistic_manager_timeslot_required'))
                    .test("to<=deadline", t('logistic_manager_to_exceed_deadline'), function (v) {
                        const deadline = this.parent?.deadline;
                        if (!v || !deadline) return true;
                        return new Date(v).getTime() <= new Date(deadline).getTime();
                    })
                    .test("to>=from", t('logistic_manager_to_before_from'), function (v) {
                        const from = this.parent?.time_slot_from_city_manager;
                        if (!v || !from) return true;
                        return new Date(v).getTime() >= new Date(from).getTime();
                    })
                : yup.string().nullable().notRequired(),

            // Finance Manager — only required when visible (NEW, mirrors city_manager)
            commission_finance_manager: showFinance
                ? yup.number()
                    .typeError(t('finance_manager_commission_required'))
                    .min(0, t('minimum_value_is_0'))
                    .when("commission_type", {
                        is: "percentage",
                        then: (s) => s.max(100, t('percentage_cannot_exceed_100')),
                        otherwise: (s) => s.max(99999, t('commission_cannot_exceed_99999')),
                    })
                : yup.number().nullable().notRequired(),

            time_slot_from_finance_manager: showFinance
                ? yup.string()
                    .required(t('finance_manager_timeslot_required'))
                    .test("from>=now", t('finance_manager_from_in_past'), (v) => !v || new Date(v).getTime() >= Date.now())
                    .test("from<=deadline", t('finance_manager_from_exceed_deadline'), function (v) {
                        const deadline = this.parent?.deadline;
                        if (!v || !deadline) return true;
                        return new Date(v).getTime() <= new Date(deadline).getTime();
                    })
                : yup.string().nullable().notRequired(),

            time_slot_to_finance_manager: showFinance
                ? yup.string()
                    .required(t('finance_manager_timeslot_required'))
                    .test("to<=deadline", t('finance_manager_to_exceed_deadline'), function (v) {
                        const deadline = this.parent?.deadline;
                        if (!v || !deadline) return true;
                        return new Date(v).getTime() <= new Date(deadline).getTime();
                    })
                    .test("to>=from", t('finance_manager_to_before_from'), function (v) {
                        const from = this.parent?.time_slot_from_finance_manager;
                        if (!v || !from) return true;
                        return new Date(v).getTime() >= new Date(from).getTime();
                    })
                : yup.string().nullable().notRequired(),

            deduction_reason: yup.string().when([], {
                is: () => true,
                then: (schema) =>
                    schema.test(
                        "deduction-reason-required",
                        t('deduction_reason_required_on_change'),
                        function (value) {
                            if (!rfq_commission) return true;

                            const cityChanged = showCity &&
                                Number(this.parent.commission_city_manager) !== Number(rfq_commission.commission_city_manager);

                            const financeChanged = showFinance &&
                                Number(this.parent.commission_finance_manager) !== Number(rfq_commission.commission_finance_manager);

                            const changed = cityChanged || financeChanged;

                            if (!changed) return true;

                            if (!value || !value.trim()) {
                                return this.createError({ message: t('deduction_reason_is_required') });
                            }
                            if (value.trim().length < 5) {
                                return this.createError({ message: t('deduction_reason_min_length') });
                            }
                            if (value.trim().length > 255) {
                                return this.createError({ message: t('deduction_reason_max_length') });
                            }
                            return true;
                        }
                    ),
            }),
        });
    };

    const {
        register,
        handleSubmit,
        setValue,
        watch,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues: {
            rfq_ids: [rfqId],
            commission_type: "percentage",
            notes: null,
            time_slot_from_city_manager: "",
            time_slot_to_city_manager: "",
            time_slot_from_city_rep: "",
            time_slot_to_city_rep: "",
            time_slot_from_finance_manager: "",
            time_slot_to_finance_manager: "",
            time_slot_from_finance_rep: "",
            time_slot_to_finance_rep: "",
            deduction_reason: "",
        }, resolver: yupResolver(schema(t, rfq_commission, currentUserRole, isMember))
    });

    const { cities, countries, offices } = useSelector((state) => state.internalUser);
    const hasUpdatePermission = useHasPermission('order.update-commission-deadline');
    const isAuthorized = hasUpdatePermission || isAdminRole;

    useEffect(() => {
        dispatch(getRfqCommission({ rfq_id: rfqId }));
        dispatch(getSettingData());
    }, [dispatch]);

    const commissionType = watch("commission_type");

    // const currentCommissionValues = watch([
    //     "commission_city_manager",
    //     "commission_city_rep",
    // ]);

    // const isCommissionChanged =
    //     rfq_commission &&
    //     (
    //         Number(currentCommissionValues[0]) !== Number(rfq_commission.commission_city_manager) ||
    //         Number(currentCommissionValues[1]) !== Number(rfq_commission.commission_city_rep)
    //     );

    const currentCommissionValues = watch([
        "commission_city_manager",
        "commission_city_rep",
        "commission_finance_manager",
        "commission_finance_rep",
    ]);

    const isCommissionChanged =
        rfq_commission &&
        (
            (showCity && (
                Number(currentCommissionValues[0]) !== Number(rfq_commission.commission_city_manager) ||
                Number(currentCommissionValues[1]) !== Number(rfq_commission.commission_city_rep)
            )) ||
            (showFinance && (
                Number(currentCommissionValues[2]) !== Number(rfq_commission.commission_finance_manager) ||
                Number(currentCommissionValues[3]) !== Number(rfq_commission.commission_finance_rep)
            ))
        );

    // const defaultCommissions = [
    //     { text: t('set_commission_for_logistic_manager'), value: 0, key: "commission_city_manager", fromKey: "time_slot_from_city_manager", toKey: "time_slot_to_city_manager" },
    //     { text: t('set_commission_for_logistic_member'), value: 0, key: "commission_city_rep", fromKey: "time_slot_from_city_rep", toKey: "time_slot_to_city_rep" },
    // ];

    const allCommissions = [
        { text: t('set_commission_for_logistic_member'), value: 0, key: "commission_city_rep", fromKey: "time_slot_from_city_rep", toKey: "time_slot_to_city_rep", section: "city" },
        { text: t('set_commission_for_logistic_manager'), value: 0, key: "commission_city_manager", fromKey: "time_slot_from_city_manager", toKey: "time_slot_to_city_manager", section: "city" },
        { text: t('set_commission_for_finance_member'), value: 0, key: "commission_finance_rep", fromKey: "time_slot_from_finance_rep", toKey: "time_slot_to_finance_rep", section: "finance" },
        { text: t('set_commission_for_finance_manager'), value: 0, key: "commission_finance_manager", fromKey: "time_slot_from_finance_manager", toKey: "time_slot_to_finance_manager", section: "finance" },
    ];

    const defaultCommissions = allCommissions.filter((item) => {
        if (isMember && item.key.includes("manager")) return false;
        if (item.section === "city") return showCity;
        if (item.section === "finance") return showFinance;
        return true;
    });

    const onSubmit = async (data) => {
        try {
            const payload = {
                ...data,
                rfq_id: rfqId,
            };
            const result = await dispatch(updateRfqCommission(payload)).unwrap();
            if (result?.status) {
                Toaster.success(result.message || t('commission_updated_success'));
                dispatch(resetStatus());
                reset();
                onClose();
            } else {
                Toaster.error(result.message || ct('something_went_wrong'));
                dispatch(resetStatus());
            }
        } catch (err) {
            Toaster.error(err?.message || t('failed_to_update_commission'));
            dispatch(resetStatus());
        }
    };


    useEffect(() => {
        if (!rfq_commission) return;

        const formatDateTime = (value) => {
            if (!value) return "";
            return value.slice(0, 16); // ✅ correct for datetime-local
        };

        const formattedData = {
            ...rfq_commission,
            deduction_reason: rfq_commission.deduction_reason || "",

            time_slot_from_city_manager: formatDateTime(rfq_commission.city_manager_time_slot_from),
            time_slot_to_city_manager: formatDateTime(rfq_commission.city_manager_time_slot_to),

            time_slot_from_city_rep: formatDateTime(rfq_commission.city_rep_time_slot_from),
            time_slot_to_city_rep: formatDateTime(rfq_commission.city_rep_time_slot_to),

            time_slot_from_finance_manager: formatDateTime(rfq_commission.finance_manager_time_slot_from),
            time_slot_to_finance_manager: formatDateTime(rfq_commission.finance_manager_time_slot_to),

            time_slot_from_finance_rep: formatDateTime(rfq_commission.finance_rep_time_slot_from),
            time_slot_to_finance_rep: formatDateTime(rfq_commission.finance_rep_time_slot_to),

            deadline: formatDateTime(rfq_commission.deadline),
        };

        console.log(formattedData);
        reset(formattedData);

    }, [rfq_commission]);

    const now = new Date();
    const minDateTime = now.toISOString().slice(0, 16); // YYYY-MM-DDTHH:MM
    const deadlineValue = watch("deadline");


    const [selectedUsers, setSelectedUsers] = useState(null);


    return (
        <Dialog
            open={isOpen}
            handler={onClose}
            size="md"
            className="rounded-2xl p-0"
        >
            {loading && <ShowLoader />}

            <DialogHeader className="flex justify-between items-center px-6 py-4 border-b">
                <h2 className="text-2xl font-bold text-gray-900">
                    {t('edit_order_commission_deadline_title')}
                </h2>
            </DialogHeader>

            <form onSubmit={handleSubmit(onSubmit)}>
                <button type="button" className="sr-only" aria-hidden="true" tabIndex={0} />
                <div className="px-6 max-h-[65vh] overflow-y-auto mt-5">
                    <DialogBody>
                        <div className="grid grid-cols-2 md:grid-cols-2 gap-6 mb-6">

                            <div>
                                <Typography variant="small" className="mb-2 font-medium">
                                    {t('order_deadline_date_time_label')} <span className="text-red-500">*</span>
                                </Typography>
                                <Input
                                    type="datetime-local"
                                    min={minDateTime}
                                    {...register("deadline")}
                                    disabled={!isAuthorized}
                                    className="!border-t-blue-gray-200 focus:!border-t-gray-900"
                                    labelProps={{ className: "before:content-none after:content-none" }}
                                />
                                {errors.deadline && (
                                    <p className="text-red-500 text-sm">{errors.deadline.message}</p>
                                )}
                            </div>

                            {/* Priority */}
                            <div>
                                <Typography variant="small" className="mb-2 font-medium">
                                    {t('order_priority_label')} <span className="text-red-500">*</span>
                                </Typography>
                                <Select
                                    placeholder={t('select_priority_placeholder')}
                                    options={priorities}
                                    value={priorities.find(p => p.value === watch("priority")) || null}
                                    onChange={(priority) =>
                                        setValue("priority", priority?.value, { shouldValidate: true })
                                    }
                                    styles={customSelectStyles}
                                    isClearable
                                    isDisabled={!isAuthorized}
                                />
                                {errors.priority && (
                                    <p className="text-red-500 text-sm">{errors.priority.message}</p>
                                )}
                            </div>
                        </div>

                        {/* Commission Section */}
                        <div className="grid grid-cols-1 gap-6 mb-6">
                            <div>
                                <Typography variant="small" className="mb-2 font-medium">
                                    {t('set_commission_for_each_role_label')}
                                </Typography>
                                <div className="flex items-center gap-6 mb-3">
                                    <label className="flex items-center gap-2 text-sm">
                                        <input type="radio" value="percentage" {...register("commission_type")} disabled={!isAuthorized} />
                                        {t('percentage_commission_label')}
                                    </label>
                                    <label className="flex items-center gap-2 text-sm">
                                        <input type="radio" value="flat" {...register("commission_type")} disabled={!isAuthorized} />
                                        {t('flat_commission_label')}
                                    </label>
                                </div>

                                <div className="space-y-4">
                                    {defaultCommissions.map((item, index) => (
                                        <div key={index} className="flex flex-col gap-1">
                                            <div className="bg-gray-50 rounded-md">

                                                <div className="flex items-center justify-between px-4 py-2">
                                                    <p className="text-sm text-gray-800">{item.text}</p>
                                                    <div className="flex items-center gap-3 flex-wrap justify-end">
                                                        <div className="flex items-center gap-2">
                                                            <input
                                                                step="0.01"
                                                                type="number"
                                                                min={"0"}
                                                                {...register(item.key)}
                                                                disabled={!isAuthorized}
                                                                className={`w-20 text-center border rounded-md py-1 text-sm ${errors[item.key] ? "border-red-500" : "border-gray-300"}`}
                                                            />
                                                            <span className="text-gray-600 text-sm">
                                                                {watch("commission_type") === "percentage" ? "%" : "SAR"}
                                                            </span>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="flex items-center justify-between px-4 py-2">
                                                    <span className="text-gray-600 text-xs whitespace-nowrap">
                                                        {t('time_slot_label')}
                                                    </span>
                                                    <div className="flex items-center gap-2">
                                                        <input
                                                            type="datetime-local"
                                                            disabled={
                                                                !isAuthorized ||
                                                                !deadlineValue
                                                            }
                                                            min={minDateTime}
                                                            max={deadlineValue || undefined}
                                                            {...register(item.fromKey)}
                                                            className={`w-[175px] text-center border rounded-md py-1 text-sm ${errors[item.fromKey] ? "border-red-500" : "border-gray-300"}`}
                                                        />
                                                        <input
                                                            type="datetime-local"
                                                            disabled={
                                                                !isAuthorized ||
                                                                !deadlineValue
                                                            }
                                                            min={watch(item.fromKey) || minDateTime}
                                                            max={deadlineValue || undefined}
                                                            {...register(item.toKey)}
                                                            className={`w-[175px] text-center border rounded-md py-1 text-sm ${errors[item.toKey] ? "border-red-500" : "border-gray-300"}`}
                                                        />
                                                        {isAuthorized &&
                                                            (watch(item.fromKey) || watch(item.toKey)) && (
                                                                <XCircleIcon
                                                                    className="h-5 w-5 text-red-500 cursor-pointer hover:text-red-700 transition-colors"
                                                                    onClick={() => {
                                                                        setValue(item.fromKey, "", { shouldValidate: true });
                                                                        setValue(item.toKey, "", { shouldValidate: true });
                                                                    }}
                                                                />
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                            {errors[item.key] && (
                                                <p className="text-red-500 text-xs px-4">{errors[item.key].message}</p>
                                            )}
                                            {(errors[item.fromKey] || errors[item.toKey]) && (
                                                <p className="text-red-500 text-xs px-4">
                                                    {(errors[item.fromKey] || errors[item.toKey])?.message}
                                                </p>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Notes */}
                            <div>
                                <label className="block text-sm font-medium mb-1">
                                    {t('note_label')} <span className="text-red-500">*</span>
                                </label>
                                <textarea
                                    rows="3"
                                    className="w-full border rounded-lg px-3 py-2"
                                    {...register("notes")}
                                    placeholder={t('note_placeholder')}
                                    disabled={!isAuthorized}
                                ></textarea>
                                {errors.notes && (
                                    <p className="text-red-500 text-sm">{errors.notes.message}</p>
                                )}
                            </div>

                            {/* Deduction Reason */}
                            {isCommissionChanged && (
                                <div>
                                    <label className="block text-sm font-medium mb-1">
                                        {t('deduction_reason_label')} <span className="text-red-500">*</span>
                                    </label>

                                    <textarea
                                        rows="3"
                                        className="w-full border rounded-lg px-3 py-2"
                                        {...register("deduction_reason")}
                                        disabled={!isAuthorized}
                                        placeholder={t('deduction_reason_placeholder')}
                                    ></textarea>

                                    {errors.deduction_reason && (
                                        <p className="text-red-500 text-sm">
                                            {errors.deduction_reason.message}
                                        </p>
                                    )}
                                </div>
                            )}

                            {/* Important Commission Notice */}
                            <div className="mb-4 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3">
                                <p className="text-sm font-medium text-amber-900">
                                    {t('important_notice_title')}
                                </p>

                                <p className="mt-1 text-sm text-amber-800 leading-relaxed">
                                    {t('commission_deduction_notice')}
                                </p>
                            </div>
                        </div>
                    </DialogBody>
                </div>

                <DialogFooter className="flex justify-end gap-4 border-t pt-4">
                    <button type="button" onClick={onClose} className="px-5 py-2 rounded-lg text-gray-700 hover:bg-gray-100">
                        {t('not_now_button')}
                    </button>
                    <button
                        type="submit"
                        disabled={!isAuthorized}
                        className={`px-5 py-2 rounded-lg font-medium shadow-sm transition-all ${isAuthorized
                            ? "bg-yellow-400 hover:bg-yellow-500 text-gray-900 cursor-pointer"
                            : "bg-gray-300 text-gray-500 cursor-not-allowed opacity-60"
                            }`}
                    >
                        {t('update_now_button')}
                    </button>
                </DialogFooter>
            </form>
        </Dialog>
    );
}

export default EditRFQCommissionDeadline;
